import React from 'react';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import { CustomDragLayer } from './CustomDragLayer';

const DragAndDropContextProvider: React.FunctionComponent = ({
  children
}: {
  children?: React.ReactNode;
}) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <CustomDragLayer />
      {children}
    </DndProvider>
  );
};

export default DragAndDropContextProvider;
